const
	hooks = require('../modules/hooks'),
	cmd = require('../utils/cmd'),
	debounce = require('../utils/debounce'),
	throttle = require('../utils/throttle'),
	pubsub = require('../utils/pubsub'),
	screen = require('../utils/screen'),
	storage = require('../utils/storage'),
	querystring = require('../utils/querystring'),
	ModuleLoader = require('../utils/ModuleLoader'),
	debug = require('./debug'),
	core = window.advert || {},
	currentCmds = core.cmd;
let config = {};

performance.mark('advert - core - load - start');

window.addEventListener('scroll', throttle(_scroll, 250));
window.addEventListener('resize', debounce(_resize, 250));
window.addEventListener('orientationchange', debounce(_resize, 250));

/**
 * Core initialization + hook trigger
 *
 * @alias window.advert.init
 *
 * @param options
 * @param userHooks
 */
core.init = function(options, userHooks) {
	performance.mark('advert - core - initialisation - start');

	if (typeof options === 'undefined') {
		throw Error('advert.core - No options defined!');
	}

	config = options;

	if (typeof userHooks !== 'undefined') {
		hooks.init(userHooks);
	}

	// Handle module loading
	pubsub.subscribe('module.load', _handleModuleLoad);
	core.modules = new ModuleLoader(core.modules);

	pubsub.publish('init');
	performance.mark('advert - core - initialisation - end');
};

/**
 * When a module is loaded, init it and check if cmds can continue
 * @param module
 * @private
 */
function _handleModuleLoad(module) {
	return _initModule(module).then(() => {
		if (_areAllExpectedModulesReady()) {
			cmd.accept('loaded');
		}
	});
}

/**
 * Initialise a module with its config
 * @param name Module name
 * @param module Module object
 * @private
 */
function _initModule([name, module]) {
	return (typeof module.init === 'function' ? module.init(config[name]) : Promise.resolve()).then(() => {
		if (typeof module.actions === 'object') {
			Object.assign(core, module.actions);
		}

		core.modules[name] = module;

		pubsub.publish('module.initialised', [name, module]);
	});
}

/**
 * publish hook on scroll event
 *
 * @private
 */
function _scroll() {
	pubsub.publish('scroll', window.scrollY);
}

/**
 * publish hook on resize event
 *
 * @private
 */
function _resize() {
	pubsub.publish('resize', screen.getSize().width);
}

function _areAllExpectedModulesReady() {
	return !Object.keys(config).some((requiredModule) => {
		return typeof window.advert.modules[requiredModule] === 'undefined';
	});
}

core.pubsub = pubsub;
core.storage = storage;
core.querystring = querystring;
core.screen = screen;
core.version = '6.2.2';
core.cmd = cmd;

window.advert = core;

cmd.init(currentCmds, ['ready']);

if (typeof querystring.get('advertdebug') !== 'undefined') {
	debug.load();
}

performance.mark('advert - core - load - end');
